import BaseHttpService from "../baseService";

class BankAccountsServiceProvider extends BaseHttpService {
	constructor() {
		super("user-bank-accounts");
	}

	/**
	 * Add bank account
	 *
	 * @async
	 * @version 1.0.0
	 */
	public addBankAccount(data: AccountInput): HttpService.BaseResponse {
		return this.getResource().post("add-bank-account", data);
	}
}

export enum AccountType {
	SHABA = "SHABA",
	CARD = "CARD",
}

export enum AccountStatus {
	PENDING = "PENDING",
	REJECTED = "REJECTED",
	CONFIRMED = "CONFIRMED",
}

export type AccountInput = {
	name: string;
	value: string;
	type: AccountType;
};

export type AccountModel = {
	id: string;
	name: string;
	value: string;
	bank?: string;
	description?: string;
	metadata?: string;
	createdDate: number;
	lastModifiedDate: number;
	status: AccountStatus;
	type: AccountType;
};

const BankAccountService = new BankAccountsServiceProvider();

export default BankAccountService;
